import gql from 'graphql-tag';

export const fetchCategories = gql`
  query fetchCategories($proveedorRut: String = null) {
    dashboard_categories(order_by: {mdm_name: asc}) {
      id
      code
      name: mdm_name
    }
    usedCategories: dashboard_rfq_detalle_adjudicacion(where: {proveedor_rut: {_eq: $proveedorRut}}, order_by: {categoria_nombre: asc}, distinct_on: categoria_nombre) {
      id
      code: categoria_id
      name: categoria_nombre
    }
  }
`;

export const fetchGraphData = gql`
  query fetchGraphData(
    $startDate: String!
    $endDate: String!
    $myEnterprise: Boolean = false
    $transactionsReport: Boolean = true
    $categoryId: String = null
    $productName: String = null
    $companyId: Int = null
  ) {
    totalReports(endDate: $endDate, myEnterprise: $myEnterprise, startDate: $startDate, transactionsReport: $transactionsReport, categoryId: $categoryId, , productName: $productName, companyId: $companyId) {
      result
      rfq_fecha_creacion
    }
  }
`;

export const reporteGeneralDeTransacciones = gql`
  query reporteGeneralDeTransacciones(
    $limit: Int = 15
    $offset: Int = 0
    $startDate: timestamp
    $endDate: timestamp
    $enterpriseId: String = null
    $companyId: Int = null
    $categoryId: String = null
    $productName: String = null
  ) {
    generalTransactions: dashboard_rfq_detalle_adjudicacion(
      limit: $limit
      offset: $offset
      where: {
        rfq_fecha_creacion: { _gte: $startDate, _lte: $endDate }
        proveedor_rut: { _eq: $enterpriseId }
        categoria_id: { _eq: $categoryId }
        comprador_id: { _eq: $companyId }
        item_descripcion: { _ilike: $productName }
      }
      order_by: { rfq_fecha_creacion: asc }
    ) {
      CompradorNombre: comprador_nombre
      CategoriaId: categoria_id
      CategoriaNombre: categoria_nombre
      ItemDescripcion: item_descripcion
      ItemCantidad: item_cantidad
      ItemPosicion: item_posicion
      RfqFechaCreacion: rfq_fecha_creacion
      RfqFechaCierre: rfq_fecha_cierre
      RfqPrecio: rfq_precio
      RfqMoneda: rfq_moneda
    }
    totalRows: dashboard_rfq_detalle_adjudicacion_aggregate(
      where: {
        rfq_fecha_creacion: { _gte: $startDate, _lte: $endDate }
        proveedor_rut: { _eq: $enterpriseId }
        categoria_id: { _eq: $categoryId }
        comprador_id: { _eq: $companyId }
        item_descripcion: { _ilike: $productName }
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;

export const companySelector = gql`
  query companySelector($proveedorRut: String = "") {
    uniqueCompanies: dashboard_rfq_detalle_adjudicacion(
      distinct_on: comprador_id
      where: { proveedor_rut: { _eq: $proveedorRut } }
    ) {
      Id: id
      CompradorNombre: comprador_nombre
      CompradorRUT: comprador_rut
      ProveedorRUT: proveedor_rut
      ProveedorNombre: proveedor_nombre
      comprador_id
    }
  }
`;

export const GET_USER_PORTALS = gql`
query GET_USER_PORTALS {
  userPortals {
    DisplayName
    Name
    Url
    id
  }
}
`;

export const GET_NEWS = gql`
query GET_NEWS($language: String = "en") {
  dashboard_novedades: dashboard_resumen_cotizaciones_y_montos(where: {language: {_eq: $language}}) {
    id
    statistic_number_1
    statistic_number_2
    subTitle_1
    subTitle_2
    title_1
    title_2
  }
}
`;



// WEBPACK FOOTER //
// ./src/store/graphql/queries/dashboard.js